<template>
<div>
    <v-row>
        <v-col cols="1"></v-col>
        <v-col cols="10">
            <v-autocomplete v-model="key" :items="keys" clearable :loading="loading" :search-input.sync="search" hide-no-data no-filter @click:clear="keys = []" item-text="oem" :item-value="item => item" @input="input" label="OEM/FCC/IC/iSKU" solo return-object>
                <v-list-tile name="ava1" class="pa-2" slot="item" slot-scope="{item}">
                    <v-avatar left>
                        <v-img v-bind:src="item.image"></v-img>
                    </v-avatar>
                    {{item.oem}} - {{item.fcc}} - {{item.ic}}
                </v-list-tile>
            </v-autocomplete>
        </v-col>
        <v-col cols="1">

        </v-col>
    </v-row>
    <v-row v-if="key != null">
        <v-col cols="1"></v-col>
        <v-col cols="10">
            <v-card>
                <v-card-title style="height:50px;margin-top:-3% !important;">
                    Move Inventory:
                    <div style="margin-left:10px">
                        <v-chip outlined color="primary">{{key.oem}}</v-chip> -
                        <v-chip outlined color="primary">{{key.fcc}}</v-chip> -
                        <v-chip outlined color="primary">{{key.ic}}</v-chip>
                    </div>
                </v-card-title>
                <v-divider></v-divider>
                <v-form lazy-validation>
                    <v-row style="height:60px">
                        <v-col cols="1"></v-col>
                        <v-col cols="4">
                            <v-select v-model="request.from" :items="locations" @input="fromChange" :item-value="item => item" :item-text="item => item.name" :rules="[rules.required]" filled solo label="From:" dense></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-btn :loading="stackLoading" :disabled="stackLoading" color="info">
                                {{maxStock}} in stock
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="height:60px">
                        <v-col cols="1"></v-col>
                        <v-col cols="4">
                            <v-select v-model="request.to" :items="locations" :rules="[rules.required]" :item-value="item => item" :item-text="item => item.name" filled solo label="To:" dense></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-model="request.amount" :rules="[rules.required]" dense type="number" required label="Amount:" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row style="height:60px">
                        <v-col cols="1"></v-col>
                        <v-col cols="8">
                            <v-text-field v-model="request.notes" dense type="text" required label="Notes:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="2">
                        </v-col>
                    </v-row>
                    <v-row align="center" specify="center" style="min-height:60px">
                        <v-col cols="4"></v-col>
                        <v-col cols="2">
                            <v-btn color="success" @click="update">
                                Move Inventory
                            </v-btn>
                        </v-col>
                        <v-col cols="1"></v-col>
                    </v-row>
                </v-form>

            </v-card>
        </v-col>
        <v-col cols="1"></v-col>
    </v-row>
</div>

</template>

<script>

export default {
    created() {
            this.locations = this.$store.state.token.locations;
        },
        data: () => ({
            locations: [],
            keys: [],
            key: null,
            maxStock: 0,
            search: '',
            stackLoading: false,
            rules: {
                required: value => !!value || 'Required.'
            },
            loading: false,
            request: {
                oem: '',
                notes: '',
                to: null,
                from: null,
            },
        }),
        watch: {
            search(val) {
                if (this.loading) return;
                if (val == '' || val == null) return;
                this.loading = true;
                this.$api.searchKey(val).then((response) => {
                    if (response.status == 200)
                        this.keys = response.data;
                    this.loading = false;
                }).then(error => {
                    this.loading = false;
                })
            }
        },
        methods: {
            fromChange(value) {
                    this.stackLoading = true;
                    if (value != null) {
                        this.$api.getStock(this.key.oem, value.id).then((res) => {
                            if (res.status == 200)
                                this.maxStock = res.data;

                            this.stackLoading = false;
                        }).catch(error => {
                            this.stackLoading = false;
                        })
                    }

                },
                update() {
                    if (this.$refs.move.validate()) {
                        this.$overlay.show(this);
                        this.$api.moveItems(this.request).then((res) => {
                            if (res.status == 200) {
                                this.key = null;
                                this.request = {
                                    oem: '',
                                    notes: '',
                                    to: null,
                                    from: null,
                                };
                                this.keys = [];
                                this.maxStock = 0;
                                this.$toasted.success("Inventory updated").goAway(1200);
                                this.$refs.move.reset();
                            }
                            this.$overlay.hide();
                        }).catch(error => {
                            this.$toasted.error("Error updating inventory").goAway(1200);
                            this.$overlay.hide();
                        })
                    }
                },
                input(value) {
                    if (value != null)
                        this.request.oem = value.oem;
                    else
                        this.request.oem = null;
                },

        }
}

</script>
